export const contributorsList = [
  { name: 'oNare', realm: '1286', desc: `ANE`, type: 'creator' },
  { name: 'DvdVgt', realm: '1022', desc: 'EoL', type: 'developer' },
  { name: 'Panda', realm: '1022', desc: 'EoL', type: 'VIP supporter' },
  { name: 'Nooby', realm: '1242', desc: '', type: 'VIP contributor' },
  { name: 'Tullen', realm: '1286', desc: 'FNE', type: 'VIP supporter' },
  { name: 'Oopsie_Dazie', realm: '1052', desc: 'GOT', type: 'VIP contributor' },
  { name: 'P', realm: '1307', desc: '', type: 'contributor' },
  { name: 'LMOY', realm: '1286', desc: 'FNE', type: 'contributor' },
  { name: 'Acveen', realm: '1289', desc: 'W4R', type: 'VIP contributor' },
  { name: 'Rami', realm: '1286', desc: 'FNE', type: 'contributor' },
  { name: 'Legend', realm: '1014', desc: 'ZBE', type: 'contributor' },
  { name: 'Bubbies', realm: '1153', desc: '', type: 'contributor' },
  { name: 'Freyja', realm: '1462', desc: '', type: 'supporter' },
  { name: 'Ian', realm: '1406', desc: 'TSS', type: 'supporter' },
  { name: 'BiteMe', realm: '1242', desc: '', type: 'contributor' },
  { name: 'ÉRA', realm: '434', desc: '', type: 'VIP contributor' },
  { name: 'KING <1G>', realm: '1289', desc: 'W4R', type: 'contributor' },
  { name: 'D i n o s a u r', realm: '1073', desc: 'SHH', type: 'supporter' },
  { name: 'WOLF', realm: '1002', desc: 'AMK', type: 'supporter' },
  { name: 'Shuuichi', realm: '128', desc: 'TLS', type: 'contributor' },
  { name: 'Bikerbobby', realm: '', desc: '', type: 'VIP contributor' },
  { name: 'STV', realm: '', desc: '', type: 'contributor' },
  { name: 'aHTu', realm: '1360', desc: 'APX', type: 'VIP contributor' },
  { name: 'Mamba', realm: '128', desc: 'BRO', type: 'contributor' },
  { name: 'HunabҜu™', realm: '1449', desc: '', type: 'contributor' },
  { name: 'Kisuke', realm: '1247', desc: 'MoM', type: 'contributor' },
  { name: 'Ani', realm: '1096', desc: 'SIC', type: 'contributor' },
  { name: 'Lucifer_Boots', realm: '1351', desc: 'INC', type: 'contributor' },
  { name: 'Envy', realm: '619', desc: 'RAW', type: 'contributor' },
  { name: 'DocHollywood', realm: '1014', desc: 'ZBE', type: 'contributor' },
  { name: 'Marvin', realm: '1101', desc: '', type: 'contributor' },
  { name: '༻Sepж༺ ', realm: '1396', desc: '', type: 'contributor' },
  { name: 'Slave', realm: '1490', desc: 'HOK', type: 'supporter' },
  { name: 'Aren', realm: '1101', desc: 'MFL', type: 'supporter' },
  { name: 'Nudes_For_RSS', realm: '1330', desc: 'PUB', type: 'VIP supporter' },
  { name: 'Harley Quinn', realm: '106', desc: 'K06', type: 'contributor' },
  { name: 'Julie', realm: '68', desc: '', type: 'contributor' },
  { name: 'Laylight', realm: '1347', desc: 'KKE', type: 'contributor' },
  { name: 'pi', realm: '1014', desc: '', type: 'supporter' },
  { name: 'Shadowlight', realm: '1360', desc: 'APX', type: 'supporter' },
  { name: 'bReal', realm: '1590', desc: 'CoC', type: 'supporter' }
]
